export const RATE_BROWSER = 'rate-browser';
export const CUSTOMERS_CREATE_LABEL = 'customers-create-label';
